import { render, staticRenderFns } from "./PersonSubGroupList.vue?vue&type=template&id=2f314887&"
import script from "./PersonSubGroupList.vue?vue&type=script&lang=js&"
export * from "./PersonSubGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports